import {
    CHANGE_PROGRESS,
    FULFILL_CASE_DRAFTS,
    FULLFILL_AVAILABLE_SYSTEM_IDS,
    RESET_VALIDATION_ERRORS_BY_FIELD,
    SET_VALIDATION_ERRORS,
    FULLFILL_CURRENT_SYSTEM_ID,
    FULLFILL_CASES,
    FULLFILL_EDITED_CASE,
    FULLFILL_REPORTS_IN_EDITED_CASE,
    CREATE_REPORT_IN_EDITED_CASE,
    UPDATE_REPORT_IN_EDITED_CASE,
    DELETE_REPORT,
    UPDATE_SUITABLE_BATCH,
    RESET_PAGE,
    CHANGE_FILTER_VALUE,
    ADD_SPECIALIST_TO_REPORT,
    DELETE_SPECIALIST_FROM_REPORT,
    UPDATE_REPORT_SIGNATURE,
    CHANGE_REPORT_VALIDATED,
    CHANGE_PAGINATION,
    UPDATE_REPORT_FILES,
    FULLFILL_REPORT_SAMPLE_TEMPLATES,
    UPDATE_SAMPLE_IN_CASE_AFTER_RESET_DUE_DAYS,
    SET_PATIENT_CONTEXT
} from './available'
import _ from 'lodash'

export default {
    [SET_PATIENT_CONTEXT](state, value) {
      state.patientContext = value
    },
    [FULLFILL_AVAILABLE_SYSTEM_IDS](state, value) {
        state.availableSystemIds = value
    },
    [FULFILL_CASE_DRAFTS](state, value) {
        state.drafts = value
    },
    [FULLFILL_CURRENT_SYSTEM_ID] (state, value) {
        state.currentSystemId = value
    },
    [FULLFILL_EDITED_CASE] (state, value) {
        state.editedCase = value
    },
    [CHANGE_PROGRESS](state, {context, value}) {
        let p =_.cloneDeep(state.progress)
        state.progress = _.set(p, context, value)
    },
    [CHANGE_FILTER_VALUE](state, {filterName, value}) {
        state.filters[filterName] = value
    },
    [RESET_PAGE](state) {
        state.pagination.page = 1
    },
    [SET_VALIDATION_ERRORS](state, {context, value}) {
        state.errorMessagesByFields[context] = value
    },
    [RESET_VALIDATION_ERRORS_BY_FIELD](state, {context, fieldName}) {
        delete state.errorMessagesByFields[context][fieldName]
    },
    [FULLFILL_CASES] (state, {cases, casesTotal}) {
        state.cases = cases
        state.totalCases = casesTotal
    },
    [CREATE_REPORT_IN_EDITED_CASE] (state, createdReport) {
        state.editedCase.reports.push(createdReport)
    },
    [UPDATE_REPORT_IN_EDITED_CASE] (state, updatedReport) {
        let reportIndex = _.findIndex(state.editedCase.reports, (r) => {
            return r.id === updatedReport.id
        })

        if (reportIndex < 0) {
            return
        }

        let reports = _.cloneDeep(state.editedCase.reports)
        reports[reportIndex] = updatedReport

        state.editedCase.reports = reports
    },
    [FULLFILL_REPORTS_IN_EDITED_CASE] (state, reports) {
        state.editedCase.reports = reports
    },
    [DELETE_REPORT] (state, reportId) {
        let reportIndex = _.findIndex(state.editedCase.reports, (r) => {
            return r.id === reportId
        })

        let reports = _.cloneDeep(state.editedCase.reports)

        reports.splice(reportIndex, 1)

        state.editedCase.reports = reports
    },
    [UPDATE_SUITABLE_BATCH] (state, {batch, availablePlaces}) {
        state.suitableBatch.batch = batch
        state.suitableBatch.availablePlaces = availablePlaces
    },
    [ADD_SPECIALIST_TO_REPORT] (state, {reportId, specialist}) {
        let reportIndex = _.findIndex(state.editedCase.reports, (r) => {
            return r.id === reportId
        })

        if (reportIndex < 0) {
            return
        }

        let reports = _.cloneDeep(state.editedCase.reports)

        reports[reportIndex].specialists.push(specialist)

        state.editedCase.reports = reports
    },
    [DELETE_SPECIALIST_FROM_REPORT] (state, {reportId, specialistId}) {
        let reportIndex = _.findIndex(state.editedCase.reports, (r) => {
            return r.id === reportId
        })

        if (reportIndex < 0) {
            return
        }

        let reports = _.cloneDeep(state.editedCase.reports)

        let specialistIndex = _.findIndex(reports[reportIndex].specialists, (s) => {
            return s.id === specialistId
        })

        if (specialistIndex < 0) {
            return
        }

        reports[reportIndex].specialists.splice(specialistIndex, 1)

        state.editedCase.reports = reports
    },
    [CHANGE_REPORT_VALIDATED] (state, {reportId, validated}) {
        let reportIndex = _.findIndex(state.editedCase.reports, (r) => {
            return r.id === reportId
        })

        if (reportIndex < 0) {
            return
        }

        let reports = _.cloneDeep(state.editedCase.reports)

        reports[reportIndex].validated = validated

        state.editedCase.reports = reports
    },
    [UPDATE_REPORT_SIGNATURE] (state, {reportId, specialistSignature, validated}) {
        let reportIndex = _.findIndex(state.editedCase.reports, (r) => {
            return r.id === reportId
        })

        if (reportIndex < 0) {
            return
        }

        let reports = _.cloneDeep(state.editedCase.reports)

        reports[reportIndex].validated = validated

        let specialistIndex = _.findIndex(reports[reportIndex].specialists, (s) => {
            return s.id === specialistSignature.id
        })

        if (specialistIndex >= 0) {
            reports[reportIndex].specialists[specialistIndex] = specialistSignature
        }
        state.editedCase.reports = reports
    },
    [CHANGE_PAGINATION] (state, pagination) {
        state.pagination = pagination
    },
    [UPDATE_REPORT_FILES] (state, {reportId, files}) {
        let reportIndex = _.findIndex(state.editedCase.reports, (r) => {
            return r.id === reportId
        })

        if (reportIndex < 0) {
            return
        }

        let reports = _.cloneDeep(state.editedCase.reports)

        reports[reportIndex].files = files

        state.editedCase.reports = reports
    },
    [FULLFILL_REPORT_SAMPLE_TEMPLATES] (state, reportSampleTemplates) {
        state.reportSampleTemplates = reportSampleTemplates
    },
    [UPDATE_SAMPLE_IN_CASE_AFTER_RESET_DUE_DAYS] (state, sampleData) {
        let sampleIndex = _.findIndex(state.editedCase.samples, (s) => {
            return s.id === sampleData.id
        })

        if (sampleIndex < 0) {
            return
        }

        let samples = _.cloneDeep(state.editedCase.samples)

        samples[sampleIndex].analysisComplete = sampleData.analysisComplete
        samples[sampleIndex].status = sampleData.status

        state.editedCase.samples = samples
    }
}